import { connect } from "react-redux";
import { bindActionCreators as bindActions } from "redux";
//
import {
  getCity,
  isModelOnline,
  isModelFavorite,
  isModelBookable,
  getModelBrand,
  getModelDiscount,
  getModelRate,
  getModelPerHour,
  getModelDistance,
  isPremiumIn,
} from "../selectors";

import ModelItem from "./ModelItem";

import {
  showModelAction,
  bookModelAction,
  favoriteModelAction,
  unfavoriteModelAction,
} from "../modules/models/actions";

const state = (state, props) => {
  const { booking } = state;
  const { model } = props;

  const city = getCity(state);
  const rate = getModelRate(state, model.id);
  const perHour = rate ? null : getModelPerHour(state, model.id);

  // Distance
  const distance = getModelDistance(state, model.id);

  return {
    discount: getModelDiscount(state, model.id),
    rate: rate || null,
    perHour,
    city,
    duration: booking.duration,
    isFavorite: isModelFavorite(state, model.id),
    isBookable: isModelBookable(state, model.id),
    isOnline: isModelOnline(state, model.id),
    brand: getModelBrand(state, model.id),
    isPremium: isPremiumIn(state),
    outcall: booking.outcall,
    distance,
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      showModel: showModelAction,
      onBook: bookModelAction,
      onFavorite: favoriteModelAction,
      onUnfavorite: unfavoriteModelAction,
    },
    dispatch
  );

export default connect(
  state,
  actions
)(ModelItem);
